var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRefund = function SvgRefund(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.061 1.881a8.333 8.333 0 1 1-2.85 4.592l.064-.261 1.611.425a6.667 6.667 0 1 0 2.545-3.709l-.185.139.848.847-3.83.884.883-3.83.914.913ZM9.17 3.333V5h2.083v1.667H6.67a.417.417 0 0 0-.075.826l.075.007h3.333a2.083 2.083 0 0 1 0 4.167H9.17v1.667H7.502v-1.667H5.42V10h4.583a.417.417 0 0 0 .075-.827l-.075-.006H6.67a2.083 2.083 0 0 1 0-4.167h.833V3.333H9.17Z",
    fill: "#515151"
  })));
};

export default SvgRefund;